import React, { Fragment } from 'react'
import TimeCounter from './../../../../commons/components/Award/TimeCounter'
import { priceFormat } from '../../../../utils/helpers'

const VoteInfo = ({award = {}}) => {
  return (
    <div className="info-period-current">
      <div className="info-period-current__content">
        <img
          className="info-period-current__content__icon"
          src="/images/img_ranking_card.svg"
        />
        
        <div className="info-period-current__content__text">
          <div className="title-intro">
            <label className="title-intro__time">
              {award.year} {award.name}
            </label>
            <h3 className="title-intro__text">
              스포키즈 {award.name} AWARDS
            </h3>
          </div>
          <div className="time-and-voting">
            <div className="time-and-voting__item">
              <label className="time-and-voting__item__text">남은 시간</label>
              <h3 className="time-and-voting__item__value">
                <TimeCounter award={award} />
              </h3>
            </div>
            <div className="time-and-voting__item">
              <label className="time-and-voting__item__text">투표수</label>
              <h3 className="time-and-voting__item__value">
                {priceFormat(award.entries_sum_total_vote)}
              </h3>
            </div>
            <div className="time-and-voting__item">
              <label className="time-and-voting__item__text">참여인원</label>
              <h3 className="time-and-voting__item__value">
                {priceFormat(award.entries_count)}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VoteInfo;
